import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { getValidationError } from "./helpers";

import {
    Input,
    TextArea,
    InputWrapper,
    SuccessIcon,
    Label,
    ErrorBorder,
    ErrorMessage,
    LabelAndErrorWrapper,
    StyledFormInput
} from "./styles";

let FormInput = ({
    isTextArea,
    placeholderAndLabel,
    onChange,
    validation,
    inverse,
    size,
    className,
    ...inputAttributes
}) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [success, setSuccess] = useState(false);
    const [focused, setFocused] = useState(false);

    const validateInput = input => {
        const validationError = getValidationError({ input, validation });

        setErrorMessage(validationError);
        validationError ? setSuccess(false) : setSuccess(true);
    };

    const handleBlur = e => {
        setFocused(false);
        if (validation) validateInput(e.target.value);
    };

    return (
        <StyledFormInput className={className}>
            <InputWrapper>
                {isTextArea ? (
                    <TextArea
                        {...inputAttributes}
                        placeholder={placeholderAndLabel}
                        onChange={e => {
                            e.target && onChange(e.target.value);
                        }}
                        onBlur={handleBlur}
                        onFocus={() => setFocused(true)}
                        inverse={inverse}
                        size={size}
                    />
                ) : (
                    <Input
                        {...inputAttributes}
                        placeholder={placeholderAndLabel}
                        onChange={e => {
                            e.target && onChange(e.target.value);
                        }}
                        onBlur={handleBlur}
                        onFocus={() => setFocused(true)}
                        inverse={inverse}
                        size={size}
                    />
                )}

                {success && <SuccessIcon inverse={inverse} />}
                {errorMessage && <ErrorBorder inverse={inverse} />}
            </InputWrapper>
            <LabelAndErrorWrapper>
                {errorMessage && (
                    <ErrorMessage inverse={inverse}>
                        {errorMessage}
                    </ErrorMessage>
                )}
                {!errorMessage && focused && (
                    <Label inverse={inverse}>{placeholderAndLabel}</Label>
                )}
            </LabelAndErrorWrapper>
        </StyledFormInput>
    );
};

FormInput.defaultProps = {
    type: "text",
    width: "100%",
    isTextArea: false
};

const formInputSizes = ["small", "medium", "large"];

FormInput.propTypes = {
    // placeholder and label text should be the same
    placeholderAndLabel: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    onChange: PropTypes.func,
    validation: PropTypes.arrayOf(
        PropTypes.shape({
            isValid: PropTypes.func,
            errorMsg: PropTypes.string
        })
    ),
    readOnly: PropTypes.bool,
    // use for inverse color styles
    inverse: PropTypes.bool,
    size: PropTypes.shape({
        sm: PropTypes.oneOf(formInputSizes),
        md: PropTypes.oneOf(formInputSizes),
        lg: PropTypes.oneOf(formInputSizes)
    }),
    required: PropTypes.bool
};

FormInput = styled(FormInput)``;
export { FormInput };
/* TO DO:
--- add hover label since the label does not show on hover anymore
*/
